
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.25 4H5.75A1.752 1.752 0 0 0 4 5.75v20.5A1.752 1.752 0 0 0 5.75 28h20.5A1.752 1.752 0 0 0 28 26.25V5.75A1.752 1.752 0 0 0 26.25 4Zm.25 22.25a.25.25 0 0 1-.25.25H20.5V17H19v9.5H5.75a.25.25 0 0 1-.25-.25v-8h6v5.25H13v-12h-1.5v5.25h-6v-11a.25.25 0 0 1 .25-.25H19v6h-2.25V13h6v-1.5H20.5v-6h5.75a.25.25 0 0 1 .25.25v20.5Z"}})])
          )
        }
      }
    